import { render, staticRenderFns } from "./PainelValidadores.vue?vue&type=template&id=059a1d42&"
import script from "./PainelValidadores.vue?vue&type=script&lang=js&"
export * from "./PainelValidadores.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports